module.exports = __webpack_public_path__ + "static/media/img-iian.f069018c.jpg";